import { useMemo, useState } from 'react'

import { GridEventListener, GridRowId, GridSortItem, useGridApiRef } from '@mui/x-data-grid'
import { useParams } from 'react-router-dom'

import { FplDataGrid } from 'components/common'
import { GET_ACCOUNTPAYABLE_RECORD_LOGS_QUERY } from 'graphql/queries'
import { useGetAccountsPayableDocumentsHistoryCollumns } from 'hooks/accountsPayable/useGetAccountsPayableDocumentsHistoryCollumns'

import ViewAccountPayableRecordLog from './ViewAccountPayableRecordLog'

const AccountPayableDocumentsHistoryTab = () => {
  const { id } = useParams<{ id?: string }>()
  const [columns] = useGetAccountsPayableDocumentsHistoryCollumns()
  const gridApiRef = useGridApiRef()
  const [selectedLogRecordId, setSelectedLogRecordId] = useState<GridRowId | null>(null)
  const [openLogDialog, setOpenLogDialog] = useState(false)

  const handleRowClick: GridEventListener<'rowClick'> = ({ id: rowId }) => {
    if (!gridApiRef.current.getRow(rowId)) return

    setSelectedLogRecordId(rowId)
    setOpenLogDialog(true)
  }

  const queryData = useMemo(
    () => ({
      query: GET_ACCOUNTPAYABLE_RECORD_LOGS_QUERY,
      entityName: 'accountPayableRecordLogs',
      queryVariables: { accountPayableRecordId: Number(id) },
      defaultSortOrder: { field: 'createdAt', sort: 'desc' } as GridSortItem,
    }),
    [id],
  )

  return (
    <>
      <FplDataGrid
        query={queryData.query}
        defaultOrder={queryData.defaultSortOrder}
        queryVariables={queryData.queryVariables}
        refetchWithDelay
        entityName={queryData.entityName}
        toolbar={{
          caption: 'History',
        }}
        columns={columns}
        gridApiRef={gridApiRef}
        onRowClick={handleRowClick}
      />

      <ViewAccountPayableRecordLog
        selectedLogRecordId={selectedLogRecordId}
        openDialog={openLogDialog}
        handleCloseDialog={() => setOpenLogDialog(false)}
        getLogRecord={(logRecordId) => gridApiRef.current.getRow(logRecordId) ?? undefined}
      />
    </>
  )
}

export default AccountPayableDocumentsHistoryTab
